import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AdminToursService {

  constructor(private http: HttpClient) { }

  serviceBaseURL: string = environment.serviceBaseUrl;

  getTours(): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/GetAllTours').toPromise();
  }

  getToursByID(tourID): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/GetAdminTourById/' + tourID).toPromise();
  }

  addTours(tours): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/AddTours', tours).toPromise();
  }

  editTours(tours): Promise<any> {
    return this.http.post(this.serviceBaseURL + 'Kesavi/EditTours', tours).toPromise();
  }

  deleteToursByID(tourID): Promise<any> {
    return this.http.get(this.serviceBaseURL + 'Kesavi/DeleteTours/' + tourID).toPromise();
  }




}
